module.exports = __webpack_public_path__ + "static/5-3de421afecf1e8478192471c59479171.jpg";